module.exports = __webpack_public_path__ + "bfafc860cf8396c8ba5939d1d84e8379.svg";


//////////////////
// WEBPACK FOOTER
// ./static/logo-payoff.svg
// module id = 961
// module chunks = 0